const EMAIL_SEND = 'RESET_EMAIL_SEND';
const EMAIL_SEND_RETRY = 'RESET_EMAIL_SEND_RETRY';
const SET_SENT = 'RESET_EMAIL_SET_SENT';
const SET_SENDING = 'RESET_EMAIL_SET_SENDING';


const resetEmailSend = (value) => ({
  type: EMAIL_SEND,
  payload: { value }
});

const resetEmailSendRetry = (value) => ({
  type: EMAIL_SEND_RETRY,
  payload: { value }
});

const resetEmailSetSent = (sent) => ({
  type: SET_SENT,
  payload: sent
});

const resetEmailSetSending = (sending) => ({
  type: SET_SENDING,
  payload: {
    sending
  }
});

export {
  EMAIL_SEND,
  SET_SENT,
  EMAIL_SEND_RETRY,
  SET_SENDING,
  resetEmailSetSending,
  resetEmailSendRetry,
  resetEmailSend,
  resetEmailSetSent
};
